import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "../..";
import { MonthlyPGGOverviewResponse } from "./monthlyPGGAPI.types";

type PGGBaseRequestParams = {
  abo: string;
  aff: string;
  locale: string;
  period: string;
};

type PGGExtendedRequestParams = PGGBaseRequestParams & {
  isoCountryCode: string;
  isoCurrencyCode: string;
};

export const monthlyPGGAPI = createApi({
  reducerPath: "monthlyPGGAPI",
  baseQuery: dynamicBaseQuery,
  endpoints: (builder) => ({
    getMonthlyPggOverview: builder.query<MonthlyPGGOverviewResponse, PGGExtendedRequestParams>({
      query: (params) => {
        const { abo, aff, locale, period, isoCountryCode, isoCurrencyCode } = params;
        const queryParams = new URLSearchParams({
          Abo: abo,
          Aff: aff,
          Locale: locale,
          Period: period,
          IsoCountryCode: isoCountryCode,
          IsoCurrencyCode: isoCurrencyCode,
        });

        return `/incentives-v2/api/pggmonthly/overview?${queryParams}`;
      },
    }),
  }),
});

export const { useGetMonthlyPggOverviewQuery } = monthlyPGGAPI;
